export const getRandomNumber = (max?: number, min?: number) => {
    const currentMax = max || 10000
    const currentMin = min || 0
    return Math.floor(Math.random() * (currentMax - currentMin)) + currentMin;
}
